import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import {
  DsAlertComponent,
  DsAnswerOptionComponent,
  DsAssessmentProgressComponent,
  DsAssessmentTimerComponent,
  DsBadgeComponent,
  DsButtonDirective,
  DsCardComponent,
  DsCheckboxDirective,
  DsDialogComponent,
  DsFieldComponent,
  DsInputDirective,
  DsProgressComponent,
  DsQuestionCardComponent,
  DsQuestionNavigatorComponent,
  DsRadioDirective,
  DsResultCardComponent,
  DsScoreVisualizationComponent,
  DsSelectDirective,
  DsStateComponent,
  DsTab,
  DsTableComponent,
  DsTabsComponent,
} from '../ui';

@Component({
  selector: 'app-design-system-page',
  imports: [
    RouterLink,
    DsAlertComponent,
    DsAnswerOptionComponent,
    DsAssessmentProgressComponent,
    DsAssessmentTimerComponent,
    DsBadgeComponent,
    DsButtonDirective,
    DsCardComponent,
    DsCheckboxDirective,
    DsDialogComponent,
    DsFieldComponent,
    DsInputDirective,
    DsProgressComponent,
    DsQuestionCardComponent,
    DsQuestionNavigatorComponent,
    DsRadioDirective,
    DsResultCardComponent,
    DsScoreVisualizationComponent,
    DsSelectDirective,
    DsStateComponent,
    DsTableComponent,
    DsTabsComponent,
  ],
  templateUrl: './design-system-page.html',
  styleUrl: './design-system-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesignSystemPage implements OnDestroy {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  @ViewChild('exampleDialog') private readonly exampleDialog?: DsDialogComponent;

  protected readonly selectedTab = signal('overview');
  protected readonly tabs: DsTab[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'activity', label: 'Activity' },
    { id: 'settings', label: 'Settings' },
  ];
  protected readonly colors = [
    { name: 'Brand', token: '--ds-color-brand' },
    { name: 'Action', token: '--ds-color-accent' },
    { name: 'Surface', token: '--ds-color-surface' },
    { name: 'Subtle surface', token: '--ds-color-surface-subtle' },
    { name: 'Text', token: '--ds-color-text' },
    { name: 'Secondary text', token: '--ds-color-text-secondary' },
    { name: 'Success', token: '--ds-color-success' },
    { name: 'Warning', token: '--ds-color-warning' },
    { name: 'Danger', token: '--ds-color-danger' },
  ];

  constructor() {
    this.title.setTitle('IQLabTest Design System');
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  ngOnDestroy(): void {
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

  protected openDialog(): void {
    this.exampleDialog?.open();
  }
}
